import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import { styled } from '@linaria/react';
import { useWaffles } from '@pelotoncycle/waffles';
import React from 'react';
import { gray2 } from '@engage/colors';
import { useCopy } from '@webtv/copy-provider';
import { PELOTON_PLATFORM } from '@webtv/env';
import { InternationalizeProvider } from '@webtv/internationalize';
import { useRemoteControlBackButton } from '@webtv/navigation';
import { AppExitConfirmationModal, LargeSpinner } from '@webtv/shared-ui';
import { getIsTVOnline, useOfflineError } from './hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var OfflineErrorModal = function OfflineErrorModal() {
  var titleCopy = useCopy('error.offlineError');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {
      "data-test-id": "errorHeader",
      children: titleCopy
    }), /*#__PURE__*/_jsx(LargeSpinner, {
      fill: gray2
    })]
  });
};

var OfflineError = function OfflineError() {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeModal = _React$useState2[0],
      setActiveModal = _React$useState2[1];

  var _useWaffles = useWaffles(),
      clearFocusTrap = _useWaffles.clearFocusTrap;

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      exitConfirmationModalActive = _React$useState4[0],
      setExitConfirmationModalActive = _React$useState4[1];

  var openModal = React.useCallback(function () {
    return setActiveModal(true);
  }, []);
  var closeModal = React.useCallback(function () {
    setActiveModal(false); // clear exitConfirmationModalActive state when the network comes back online

    setExitConfirmationModalActive(false);
  }, []);
  var onEscape = React.useCallback(function () {
    activeModal && setExitConfirmationModalActive(true);
  }, [activeModal]);
  useOfflineError(openModal, closeModal);
  useRemoteControlBackButton(onEscape, getIsTVOnline, true);
  return /*#__PURE__*/_jsx(InternationalizeProvider, {
    showLoadingSpinner: false,
    page: "error",
    pelotonPlatform: PELOTON_PLATFORM,
    children: activeModal && /*#__PURE__*/_jsx(Container, {
      children: exitConfirmationModalActive ? /*#__PURE__*/_jsx(AppExitConfirmationModal, {
        handleResume: function handleResume() {
          clearFocusTrap();
          setExitConfirmationModalActive(false);
        }
      }) : /*#__PURE__*/_jsx(OfflineErrorModal, {})
    })
  });
};

var Container = /*#__PURE__*/styled("section")({
  name: "Container",
  class: "cihawt5"
});
var Header = /*#__PURE__*/styled("h1")({
  name: "Header",
  class: "h13x6jj9"
});
export default OfflineError;

require("../../../apps/tv/.linaria-cache/packages/@webtv/error-modal/OfflineError.linaria.module.css");